module.exports = __webpack_public_path__ + "static/media/color-analyzer1.c28ce585.png";